<template>
    <Link :href="appUrl('/')">
        <img :src="logo" alt="RentRisk Logo" class="h-auto w-[300px]" />
    </Link>
</template>

<script setup>
    import { Link } from '@inertiajs/vue3';
    import logo from '../../images/rentrisk-logo.png';
</script>
